

import { Component, Emit, Inject, Model, Prop, Provide, Vue, Watch } from 'vue-property-decorator';

@Component
export default class About extends Vue {

  private getValue() {
    console.log(this.$store.state.isShow);
  }
}
